import React from 'react';

function Checkbox(props) {
  const remove = (arr, item) => {
    arr.splice(arr.indexOf(item), 1);
    return arr;
  };

  const add = (arr, item) => {
    if (!Array.isArray(arr)) return [item];
    arr.push(item);
    return arr;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      onClick={() => {
        if (props.disabled) return;
        const arr = props.input.checked
          ? remove(props.content, props.input.value)
          : add(props.content, props.input.value);
        props.input.onChange([...arr]);
      }}
      style={{ opacity: props.disabled ? 0.4 : 1, marginTop: '-9px' }}
    >
      {props.input.checked ? (
        <g fill="none" fillRule="evenodd">
          <rect width="16" height="16" fill="#415859" rx="2" />
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M4.422 7.335L3 8.771 6.788 12 13 5.268 11.403 4 6.607 9.198z"
          />
        </g>
      ) : (
        <rect
          width="16"
          height="16"
          fill="white"
          fillRule="evenodd"
          stroke="#415859"
          rx="2"
          transform="translate(1 1)"
        />
      )}
    </svg>
  );
}

export default Checkbox;
